exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-form-new-organization-person-component .content-btns{text-align:right;margin-top:2rem}.modal-form-new-organization-person-component .modal-card-head{background-color:#fff;border:none}", ""]);

// exports
